import { mapState } from 'vuex';
import get from 'lodash/get';
import { localizeDate } from '@/utils/date';
export default {
  name: 'NiotaClassicGwMgmtMapDetail',
  props: {
    item: {
      type: Object,
      required: true
    },
    mapmode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'UiTheme']),
    headerBG() {
      return './img/dtwin-factory1.png';
    },
    parallaxHeight() {
      return this.mapmode ? 130 : 200;
    },
    showSkeletonLoader() {
      return get(this.item, 'eui', true) === true;
    }
  },
  methods: {
    lastPacket(item) {
      return this.localizeDate(get(item, '_source.received_at_server')) || '-';
    },
    localizeDate(item) {
      if (item) {
        return localizeDate(item);
      }
    },
    getRssi(item) {
      return get(item, 'lastPacket._source.rssi') || 0;
    },
    getLsnr(item) {
      return get(item, 'lastPacket._source.lsnr') || 0;
    },
    openDetails(item) {
      this.$router.push(`/niota-classic/gw-mgmt/${item.id}/details`);
    }
  }
};